////////LIBRARY/////////
import React, { useEffect, useState } from 'react'
import { ThemeProvider } from 'styled-components'
import { useHistory } from 'react-router'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { bindActionCreators } from 'redux'
import moment from 'moment'
import { isUndefined, isEmpty, isNull } from 'lodash'
///////COMPONENTS///////
import theme from '../../theme/theme'
import GlobalStyle from '../../theme/GlobalStyle'
import routeList from '../../routings/settings/RouteList'
import Store from '../../helpers/Store'
import Base64Format from '../../helpers/Base64Format'
import { languagesActionCreators, loginActionCreators } from '../../store/actions'
import RenderRoutes from '../../routings/components/RenderRoutes'
import { selectLanguagesDefault } from '../../store/selectors/languages'

const App = () => {
	const [constructorFlag, setConstructorFlag] = useState(true)
	let history = useHistory()
	const isLogin = history.location.pathname === '/login'

	const { user, languagesList, defaultLanguages, languages, translations } = useSelector(
		(state) => ({
			user: state.user,
			defaultLanguages: selectLanguagesDefault(state),
			languagesList: state.languages.items,
			languages: state.languages,
			translations: state.languages.translations,
		}),
		shallowEqual
	)

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const changeLanguageHandler = (idLanguage, scope) => {
		if (scope === 'private') {
			actionsLanguages.getTranslationByLanguages(idLanguage)
		} else {
			actionsLanguages.getTranslationPublicPage(idLanguage)
		}
	}

	const actionsLogin = bindActionCreators(loginActionCreators, useDispatch())
	const actionsLanguages = bindActionCreators(languagesActionCreators, useDispatch())

	/////////////////////////////// USE EFFECT /////////////////////////////////////
	useEffect(() => {
		if (isEmpty(languagesList)) actionsLanguages.getLanguagesEnabled()
		if (isEmpty(translations) && !isNull(languages?.selectedLanguage)) actionsLanguages.getTranslationByLanguages(languages?.selectedLanguage)
	}, [])

	useEffect(() => {
		if (languagesList.length === 0) return
		if (!isLogin) {
			if (!user.identity.preferedLanguage.id) return
			changeLanguageHandler(user.identity.preferedLanguage.id, 'private')
		} else if (languages.selectedLanguage) {
			changeLanguageHandler(languages.selectedLanguage, 'public')
		} else changeLanguageHandler(2, 'public')
		if (isEmpty(languagesList)) actionsLanguages.getLanguagesEnabled()
	}, [languagesList, user.identity.preferedLanguage.id, isLogin])

	useEffect(() => {
		const userLocalStorage = Store.get('user')
		if (userLocalStorage && !isUndefined(userLocalStorage.jwttoken)) {
			const token = Base64Format.splitToken(userLocalStorage.jwttoken)
			const timeNow = moment().unix()
			const exp = token.body.exp - token.body.iat

			if (timeNow < token.body.exp) {
				actionsLogin.getCurrentUser(userLocalStorage.jwttoken)
				setTimeout(actionsLogin.getLogout, exp * 1000)
			} else {
				actionsLogin.getLogout()
			}
		} else {
			actionsLogin.getLogout()
		}
		setConstructorFlag(false)
	}, [])

	useEffect(() => {
		if (user.path.length) {
			history.push(user.path)
			//actionsModal.closeModal()
		}
	}, [user.path])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		!constructorFlag &&
		!user.isLoading &&
		languages.translations && (
			<>
				<GlobalStyle />
				<ThemeProvider theme={theme}>
					<RenderRoutes routeList={routeList} />
				</ThemeProvider>
			</>
		)
	)
}

App.propTypes = {}

export default App
